/* src/app/stocking/extra-delivery/approve-delivery-dialog/approve-delivery-dialog.component.css */
.loading {
  padding: 24px 0;
  color: #7a7a7a;
  font-size: 14px;
}
.warn {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: #fff6e5;
  border: 1px solid #f0d9a8;
  border-radius: 4px;
  padding: 12px 14px;
  margin-bottom: 16px;
  font-size: 13.5px;
  color: #7a5312;
}
.warn mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
}
.warn ul {
  margin: 6px 0 0;
  padding-left: 18px;
}
.warn-note {
  margin-top: 6px;
  font-size: 12.5px;
}
.facts {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}
.fact {
  display: flex;
  gap: 12px;
  font-size: 13.5px;
}
.fact .label {
  width: 90px;
  color: #7a7a7a;
  flex: none;
}
.fact .value {
  color: #222;
}
table.lines {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}
table.lines th,
table.lines td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
}
table.lines th {
  color: #7a7a7a;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
}
table.lines .num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
table.lines .type {
  font-size: 11.5px;
  color: #9a9a9a;
}
table.lines tfoot td {
  border-bottom: none;
  padding-top: 10px;
}
table.lines .total-label {
  color: #7a7a7a;
}
table.lines .total {
  font-weight: 500;
  font-size: 15px;
}
.approve-note {
  margin-top: 16px;
  font-size: 12.5px;
  color: #7a7a7a;
}
.reason {
  width: 100%;
  margin-top: 16px;
}
/*# sourceMappingURL=approve-delivery-dialog.component.css.map */
